import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { Providers } from "@/app/providers";
import "@/index.css";

// Initialise Sentry only in production builds that actually have a DSN, so
// local dev / DSN-less builds never send events. The DSN is injected at build
// time via VITE_SENTRY_DSN (set it in the Cloudflare Pages env vars).
const dsn = import.meta.env.VITE_SENTRY_DSN;
if (dsn && import.meta.env.PROD) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    // Errors only for now — no performance tracing — to stay within the free
    // tier. Add `tracesSampleRate` later if you want transaction monitoring.
    sendDefaultPii: false,
  });
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div
          style={{
            padding: "2rem",
            maxWidth: "28rem",
            margin: "4rem auto",
            textAlign: "center",
            fontFamily: "system-ui, sans-serif",
          }}
        >
          <h1 style={{ fontSize: "1.25rem", fontWeight: 600 }}>
            Đã có lỗi xảy ra
          </h1>
          <p style={{ color: "#666", marginTop: "0.5rem" }}>
            Vui lòng tải lại trang. Sự cố đã được ghi nhận.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: "1rem",
              padding: "0.5rem 1rem",
              borderRadius: "0.5rem",
              border: "1px solid #ccc",
              cursor: "pointer",
            }}
          >
            Tải lại trang
          </button>
        </div>
      }
    >
      <Providers />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
